// `register-service-worker` pode não estar disponível em ambientes de teste/CI.

const SW_UPDATE_EVENT = 'swUpdated';
const CHECK_INTERVAL_MS = 60 * 60 * 1000; // 1 hora

if (process.env.NODE_ENV === 'production') {
  try {
    // eslint-disable-next-line global-require
    const { register } = require('register-service-worker')

    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        console.log('[SW] App servido a partir do cache pelo service worker.');
      },

      registered(registration) {
        console.log('[SW] Service worker registrado com sucesso.');

        setInterval(() => {
          registration.update();
        }, CHECK_INTERVAL_MS);
      },

      cached() {
        console.log('[SW] Conteúdo cacheado para uso offline.');
      },

      updatefound() {
        console.log('[SW] Novo conteúdo sendo baixado...');
      },

      updated(registration) {
        console.log('[SW] Nova versão disponível.');
        document.dispatchEvent(
          new CustomEvent(SW_UPDATE_EVENT, { detail: registration })
        );
      },

      offline() {
        console.log('[SW] Sem conexão com a internet. App rodando em modo offline.');
      },

      error(error) {
        console.error('[SW] Erro durante o registro do service worker:', error);
      },
    })
  } catch (e) {
    // noop: service worker registration é opcional
  }
}

export { SW_UPDATE_EVENT };
